import React from 'react'
import { Outlet } from 'react-router-dom'

/**
 * PublicRoute Component
 * Routes wrapped with this component are accessible without authentication
 * Use this for pages like ParticipantReply etc.
 */
const PublicRoute = () => {
  return <Outlet />
}

export default PublicRoute

